webpackJsonp([174],{

/***/ 1024:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BanquetTaskBatchTable_vue__ = __webpack_require__(2541);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1140ecda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BanquetTaskBatchTable_vue__ = __webpack_require__(3288);
function injectStyle (ssrContext) {
  __webpack_require__(3285)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1140ecda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BanquetTaskBatchTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1140ecda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BanquetTaskBatchTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download

(function (root, factory) {
	if (true) {
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		// Browser globals (root is window)
		root.download = factory();
  }
}(this, function () {

	return function download(data, strFileName, strMimeType) {

		var self = window, // this script is only for browsers anyway...
			defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
			mimeType = strMimeType || defaultMime,
			payload = data,
			url = !strFileName && !strMimeType && payload,
			anchor = document.createElement("a"),
			toString = function(a){return String(a);},
			myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
			fileName = strFileName || "download",
			blob,
			reader;
			myBlob= myBlob.call ? myBlob.bind(self) : Blob ;
	  
		if(String(this)==="true"){ //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
			payload=[payload, mimeType];
			mimeType=payload[0];
			payload=payload[1];
		}


		if(url && url.length< 2048){ // if no filename and no mime, assume a url was passed as the only argument
			fileName = url.split("/").pop().split("?")[0];
			anchor.href = url; // assign href prop to temp anchor
		  	if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
        		var ajax=new XMLHttpRequest();
        		ajax.open( "GET", url, true);
        		ajax.responseType = 'blob';
        		ajax.onload= function(e){ 
				  download(e.target.response, fileName, defaultMime);
				};
        		setTimeout(function(){ ajax.send();}, 0); // allows setting custom ajax headers using the return:
			    return ajax;
			} // end if valid url?
		} // end if url?


		//go ahead and download dataURLs right away
		if(/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)){
		
			if(payload.length > (1024*1024*1.999) && myBlob !== toString ){
				payload=dataUrlToBlob(payload);
				mimeType=payload.type || defaultMime;
			}else{			
				return navigator.msSaveBlob ?  // IE10 can't do a[download], only Blobs:
					navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
					saver(payload) ; // everyone else can save dataURLs un-processed
			}
			
		}else{//not data url, is it a string with special needs?
			if(/([\x80-\xff])/.test(payload)){			  
				var i=0, tempUiArr= new Uint8Array(payload.length), mx=tempUiArr.length;
				for(i;i<mx;++i) tempUiArr[i]= payload.charCodeAt(i);
			 	payload=new myBlob([tempUiArr], {type: mimeType});
			}		  
		}
		blob = payload instanceof myBlob ?
			payload :
			new myBlob([payload], {type: mimeType}) ;


		function dataUrlToBlob(strUrl) {
			var parts= strUrl.split(/[:;,]/),
			type= parts[1],
			decoder= parts[2] == "base64" ? atob : decodeURIComponent,
			binData= decoder( parts.pop() ),
			mx= binData.length,
			i= 0,
			uiArr= new Uint8Array(mx);

			for(i;i<mx;++i) uiArr[i]= binData.charCodeAt(i);

			return new myBlob([uiArr], {type: type});
		 }

		function saver(url, winMode){

			if ('download' in anchor) { //html5 A[download]
				anchor.href = url;
				anchor.setAttribute("download", fileName);
				anchor.className = "download-js-link";
				anchor.innerHTML = "downloading...";
				anchor.style.display = "none";
				document.body.appendChild(anchor);
				setTimeout(function() {
					anchor.click();
					document.body.removeChild(anchor);
					if(winMode===true){setTimeout(function(){ self.URL.revokeObjectURL(anchor.href);}, 250 );}
				}, 66);
				return true;
			}

			// handle non-a[download] safari as best we can:
			if(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
				if(/^data:/.test(url))	url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
				if(!window.open(url)){ // popup blocked, offer direct download:
					if(confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")){ location.href=url; }
				}
				return true;
			}

			//do iframe dataURL download (old ch+FF):
			var f = document.createElement("iframe");
			document.body.appendChild(f);

			if(!winMode && /^data:/.test(url)){ // force a mime that will download:
				url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
			}
			f.src=url;
			setTimeout(function(){ document.body.removeChild(f); }, 333);

		}//end saver




		if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
			return navigator.msSaveBlob(blob, fileName);
		}

		if(self.URL){ // simple fast and modern way using Blob and URL:
			saver(self.URL.createObjectURL(blob), true);
		}else{
			// handle non-Blob()+non-URL browsers:
			if(typeof blob === "string" || blob.constructor===toString ){
				try{
					return saver( "data:" +  mimeType   + ";base64,"  +  self.btoa(blob)  );
				}catch(y){
					return saver( "data:" +  mimeType   + "," + encodeURIComponent(blob)  );
				}
			}

			// Blob but not URL support:
			reader=new FileReader();
			reader.onload=function(e){
				saver(this.result);
			};
			reader.readAsDataURL(blob);
		}
		return true;
	}; /* end download() */
}));


/***/ }),

/***/ 1388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SjProgress',
  data: function data() {
    return {
      type: 'line'
    };
  },

  props: {
    percentages: {
      type: Array,
      default: []
    },
    strokeWidth: {
      type: Number,
      default: 6
    },
    textInside: {
      type: Boolean,
      default: false
    },
    showText: {
      type: Boolean,
      default: true
    },
    status: {
      type: String,
      default: ''
    }
  },
  computed: {
    barParts: function barParts() {
      var result = [];
      for (var i in this.percentages) {
        if (this.percentages.hasOwnProperty(i) && this.percentages[i].width > 0) {
          result.push(this.percentages[i]);
        }
      }
      return result;
    },
    percentage: function percentage() {
      var result = 0;
      for (var i in this.percentages) {
        if (this.percentages.hasOwnProperty(i) && this.percentages[i].width > 0) {
          result += this.percentages[i].width;
        }
      }
      return result;
    },
    iconClass: function iconClass() {
      switch (this.status) {
        case 'success':
          return 'el-icon-circle-check';
        case 'error':
        case 'exception':
          return 'el-icon-circle-close';
        case 'ongoing':
          return 'el-icon-loading';
      }
    }
  },
  methods: {
    getColor: function getColor(status) {
      var ret = void 0;
      switch (status) {
        case 'success':
          ret = '#13ce66';
          break;
        case 'exception':
        case 'error':
          ret = '#f56c6c';
          break;
        default:
          ret = '#20a0ff';
      }
      return ret;
    },
    barStyle: function barStyle(part, index, parts) {
      var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        backgroundColor: part.status ? this.getColor(part.status) : part.color,
        borderRadius: 'none',
        display: 'inline-block',
        position: 'relative'
      }, part);

      style.width = part.width + '%';

      if (parts.length === 1) {
        style.borderRadius = '100px';
      }

      if (parts.length > 1 && index === 0) {
        style.borderRadius = '100px 0 0 100px';
      }

      if (parts.length > 1 && index + 1 === parts.length) {
        style.borderRadius = '0 100px 100px 0';
      }

      return style;
    }
  }
});

/***/ }),

/***/ 1436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjProgress_vue__ = __webpack_require__(1388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17698c40_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjProgress_vue__ = __webpack_require__(1439);
function injectStyle (ssrContext) {
  __webpack_require__(1437)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17698c40"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjProgress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17698c40_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjProgress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1437:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1438);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6cddd4f7", content, true, {});

/***/ }),

/***/ 1438:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".el-progress.is-error .el-progress__text[data-v-17698c40]{color:#f56c6c}.el-progress-bar[data-v-17698c40]{padding-right:30px;margin-right:-30px}", "", {"version":3,"sources":["/workspace/src/components/sj-progress/SjProgress.vue"],"names":[],"mappings":"AACA,0DAA0D,aAAa,CACtE,AACD,kCAAkC,mBAAmB,kBAAkB,CACtE","file":"SjProgress.vue","sourcesContent":["\n.el-progress.is-error .el-progress__text[data-v-17698c40]{color:#f56c6c\n}\n.el-progress-bar[data-v-17698c40]{padding-right:30px;margin-right:-30px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-progress",class:[
    'el-progress--' + _vm.type,
    _vm.status ? 'is-' + _vm.status : '',
    {
      'el-progress--without-text': _vm.status === '',
      'el-progress--text-inside': _vm.status === '',
    }
  ],attrs:{"role":"progressbar","aria-valuenow":_vm.percentage,"aria-valuemin":"0","aria-valuemax":"100"}},[(_vm.type === 'line')?_c('div',{staticClass:"el-progress-bar"},[_c('div',{staticClass:"el-progress-bar__outer",style:({height: _vm.strokeWidth + 'px'})},_vm._l((_vm.barParts),function(part,index){return _c('div',{staticClass:"el-progress-bar__inner",style:(_vm.barStyle(part, index, _vm.barParts))},[(_vm.showText && _vm.textInside)?_c('div',{staticClass:"el-progress-bar__innerText"},[_vm._v(_vm._s(part.width)+"%\n        ")]):_vm._e()])}),0)]):_vm._e(),_vm._v(" "),(_vm.status)?_c('div',{staticClass:"el-progress__text"},[_c('i',{class:_vm.iconClass})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_downloadjs__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_downloadjs__);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    onDownErrorFile: function onDownErrorFile(id) {
      __WEBPACK_IMPORTED_MODULE_0_downloadjs___default()(request.items.downErrorFile(id));
    },
    taskBatchPercentage: function taskBatchPercentage(row) {
      var parts = [];
      if (row.total_count <= 0) {
        return parts;
      }

      var success = 0;
      var error = 0;

      if (row.success_count > 0) {
        success = Math.round(row.success_count * 100 / row.total_count);
      }

      if (row.error_count > 0) {
        error = Math.round(row.error_count * 100 / row.total_count);
      }

      if (success + error > 100) {
        error = 100 - success;
      }

      if (success > 0) {
        parts.push({
          width: success,
          status: 'default'
        });
      }

      if (error > 0) {
        parts.push({
          width: error,
          status: 'error'
        });
      }

      return parts;
    },
    taskBatchStatus: function taskBatchStatus(row) {
      switch (row.status) {
        case 1:
        case 2:
          return 'ongoing';
        case 3:
          return 'success';
        case -1:
        case -2:
        case -3:
        case -4:
          return 'error';
      }
    }
  }
});

/***/ }),

/***/ 1444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SjProgress__ = __webpack_require__(1436);


__WEBPACK_IMPORTED_MODULE_0__SjProgress__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__SjProgress__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__SjProgress__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__SjProgress__["a" /* default */]);

/***/ }),

/***/ 1527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return taskTypes; });
var taskTypes = {
  BATCH_OPEN_TASK_GROUP_BY_SEARCH: { value: 56, label: '按搜索结果异步开启目标数' },
  BATCH_CLOSE_TASK_GROUP_BY_SEARCH: { value: 57, label: '按搜索结果异步关闭目标数' },
  USER_TAG_BY_CELLPHONE_SHA256: { value: 266, label: '批量标签池操作(按手机号sha256)' },
  BATCH_EXPORT_RECORD_REMARK: { value: 267, label: '录音标记批量导出' },
  BATCH_EXPORT_USER_AUDIT_WORKINFO: { value: 268, label: '按搜索条件导出用户职业信息' },
  BATCH_UPDATE_TASK_AFTER_MARKET_MODIFIED: { value: 269, label: '门店修改后更新任务属性' },
  BATCH_EXPORT_ORDER_SNEAK_SIMILARITY: { value: 270, label: '导出工单抓拍照片对比相似度数据' },
  BATCH_EXPORT_USER_COVERAGE_BY_MARKET_ID: { value: 271, label: '按门店ID批量导出零工覆盖指数' },
  BATCH_EXPORT_USER_COVERAGE_BY_GEO: { value: 272, label: '按经纬度批量导出零工覆盖指数' },
  BATCH_ADD_TAG_BY_CONDITION: { value: 273, label: '按搜索条件查找用户并添加标签' },
  BATCH_DEL_TAG_BY_CONDITION: { value: 274, label: '按搜索条件查找用户并删除标签' },
  BATCH_SUGGEST_PRICE_AND_CREATE_TASK: { value: 276, label: '计算门店任务建议定价并创建任务' },
  BATCH_EXPORT_LOW_SCORE_ORDER_FACE: { value: 280, label: '人脸识别分值导出' },
  BATCH_CREATE_TASK_WITH_TEMPLATE: { value: 281, label: '批量添加任务之替换选模版说明' },
  BATCH_REACTIVE_TASK: { value: 282, label: '批量重新上线任务' },
  BATCH_ORDER_EXPORT_NEW: { value: 283, label: '新版批量导出工单' },
  BATCH_EXPIRE_WORKINFO: { value: 284, label: '批量过期用户职业信息' },
  BATCH_SYNC_PERSONNEL_REQUIREMENT: { value: 285, label: '批量同步批次人员要求到任务' },
  BATCH_TASK_ORDER_EXPORT_NEW: { value: 286, label: '新版批量导出任务工单' },
  BATCH_TASK_EXPORT_NEW: { value: 287, label: '新版批量导出任务' },
  BATCH_BANQUET_TASK_IMPORT: { value: 288, label: '批量导入宴席任务' },
  BATCH_TASK_AUDIT_REFERENCE: { value: 289, label: '上传审核参照数据' }
};

/***/ }),

/***/ 2541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sj_progress__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_mixins__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_task_batch_task_batch_opts__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_downloadjs__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__banquet_task_import_demo__ = __webpack_require__(3287);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_5__views_task_batch_task_batch_mixins__["a" /* default */]],
  components: { SjProgress: __WEBPACK_IMPORTED_MODULE_4__components_sj_progress__["a" /* default */] },
  data: function data() {
    return {
      importVisible: false,
      customerid: '',
      projectid: '',
      batchid: '',
      fileList: [],
      importFile: null,
      importing: false,
      search: {
        task_type: __WEBPACK_IMPORTED_MODULE_6__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_BANQUET_TASK_IMPORT.value
      },
      searchFieldType: {
        task_type: Number
      }
    };
  },

  computed: Vuex.mapState({
    status: function status(state) {
      return state.taskBatch.status;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, request.map(['getCustomerTable', 'getCustomerDetail', 'getProjectTable', 'getProjectDetail', 'getBatchTable', 'getBatchDetail']), {
    getTableData: function getTableData(params) {
      params.task_type = __WEBPACK_IMPORTED_MODULE_6__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_BANQUET_TASK_IMPORT.value;
      return request.common('queryWaitProcessJobsApi', params);
    },
    openImport: function openImport() {
      var _this = this;

      this.resetImport();
      this.importVisible = true;
      request.common('banquetTaskImportConfig').then(function (_ref) {
        var data = _ref.data;

        if (data && Number(data.customerid) > 0) {
          _this.customerid = String(data.customerid);
        }
      });
    },
    resetImport: function resetImport() {
      this.customerid = '';
      this.projectid = '';
      this.batchid = '';
      this.fileList = [];
      this.importFile = null;
    },
    queryProject: function queryProject(params) {
      return this.getProjectTable(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
        customerid: this.customerid
      }, params));
    },
    queryBatch: function queryBatch(params) {
      return this.getBatchTable(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
        customerid: this.customerid,
        projectid: this.projectid,
        per_page: 100
      }, params));
    },
    onCustomerChange: function onCustomerChange() {
      this.projectid = '';
      this.batchid = '';
    },
    onProjectChange: function onProjectChange() {
      this.batchid = '';
    },
    onFileChange: function onFileChange(file, fileList) {
      this.fileList = fileList.slice(-1);
      this.importFile = file.raw;
    },
    downloadDemo: function downloadDemo() {
      this.$export('宴席任务导入Demo', Object(__WEBPACK_IMPORTED_MODULE_8__banquet_task_import_demo__["b" /* banquetImportDemoRows */])(), {
        fileHeader: Object(__WEBPACK_IMPORTED_MODULE_8__banquet_task_import_demo__["a" /* banquetImportDemoHeader */])()
      });
    },
    onFileRemove: function onFileRemove() {
      this.fileList = [];
      this.importFile = null;
    },
    submitImport: function submitImport() {
      var _this2 = this;

      if (!this.customerid || !this.projectid || !this.batchid) {
        this.$message.error('请选择客户、项目、批次');
        return;
      }
      if (!this.importFile) {
        this.$message.error('请选择表格');
        return;
      }
      var formData = new FormData();
      formData.append('file', this.importFile);
      formData.append('params', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        customerid: Number(this.customerid),
        projectid: Number(this.projectid),
        batchid: Number(this.batchid)
      }));
      this.importing = true;
      request.common('banquetTaskImport', formData).then(function () {
        _this2.importing = false;
        _this2.$message.success('已创建批量任务');
        _this2.importVisible = false;
        _this2.onRefresh();
      }).catch(function () {
        _this2.importing = false;
      });
    },
    onDownSourceFile: function onDownSourceFile(id) {
      __WEBPACK_IMPORTED_MODULE_7_downloadjs___default()(request.items.downSourceFile(id));
    },
    batchStatusLabel: function batchStatusLabel(value) {
      var found = this.status.find(function (item) {
        return item.value === value;
      });
      return found ? found.label : value;
    }
  })
});

/***/ }),

/***/ 3285:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3286);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2a7e389c", content, true, {});

/***/ }),

/***/ 3286:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".link-text[data-v-1140ecda]{color:#409eff;cursor:pointer}.link-text[data-v-1140ecda]:hover{text-decoration:underline}", "", {"version":3,"sources":["/workspace/src/views/banquet-task/pages/BanquetTaskBatchTable.vue"],"names":[],"mappings":"AACA,4BAA4B,cAAc,cAAc,CACvD,AACD,kCAAkC,yBAAyB,CAC1D","file":"BanquetTaskBatchTable.vue","sourcesContent":["\n.link-text[data-v-1140ecda]{color:#409EFF;cursor:pointer\n}\n.link-text[data-v-1140ecda]:hover{text-decoration:underline\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = banquetImportDemoRows;
/* harmony export (immutable) */ __webpack_exports__["a"] = banquetImportDemoHeader;
var HEADERS = ['业务员勤策经销商大区', '宴席用酒品牌', '用酒品项', '业务员勤策经销商名称', '宴席供酒单位编码', '宴席供酒单位名称', '宴席申报单号', '宴席政策', '宴席类型', '宴席主宴时间', '宴席举办地（省）', '宴席举办地（市）', '宴席举办地（区）', '宴席举办地（详细地址）', '宴席举办地（经纬度解析）', '宴席举办地（经度）', '宴席举办地（纬度）', '酒店名称', '包间名称', '预计开展桌数', '登记用酒箱数', '登记用酒盒数', '登记用酒瓶数', '登记用酒总瓶数', '退酒箱数', '退酒盒数', '退酒瓶数', '退酒总瓶数', '开瓶数', '追加用酒箱数', '追加用酒盒数', '追加用酒瓶数', '发放核销券数量', '核销核销券数量'];

var ROWS = [['四川大区', '五粮春', '五粮春（二代）', '自贡五香酒业有限公司', 'ZD1683598088184', '优家便利店', 'YX202609171765587', '2026年五粮春宴席（二代）', '婚宴', '2026-09-23 11:00:00', '四川省', '自贡市', '富顺县', '富顺', '四川省自贡市富顺县兜山镇207省道', '105.01288', '29.081787', '坝坝宴', '无', '48', '5', '30', '0', '60', '0', '0', '0', '0', '0', '5', '30', '0', '0', '0'], ['晋冀大区', '五粮春', '五粮春（二代）', '朔州市朔城区酒久源酒类经销部', 'ZD1734769419539', '瑞通泸州老窖店', 'YX202609211775735', '2026年五粮春宴席（二代）', '生日宴', '2026-09-23 12:00:00', '山西省', '朔州市', '山阴县', '北周庄镇', '山西省朔州市山阴县北周庄镇二淅线', '112.827965', '39.59598', '北周庄老红场地', '一楼', '25', '9', '0', '0', '54', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], ['四川大区', '五粮春', '五粮春（二代）', '四川春享汇供应链管理有限公司', 'ZD320402', '御岭超市', 'YX202609201773970', '2026年五粮春宴席（二代）', '白事', '2026-09-23 12:00:00', '四川省', '成都市', '简阳市', '成都市简阳市', '四川省成都市简阳市贾家街道318国道东部新区种子乐园', '104.35543823242188', '30.452993392944336', '铂宴主题宴会酒店', '大厅', '24', '5', '0', '0', '30', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], ['四川大区', '五粮春', '五粮春（二代）', '内江春盛酒业有限责任公司', 'ZD477143', '嘉越达商贸部', 'YX202609201774392', '2026年五粮春宴席（二代）', '生日宴', '2026-09-23 11:00:00', '四川省', '内江市', '东兴区', '田家镇石缸村', '四川省内江市东兴区田家镇K10县道', '105.10602', '29.68917', '田家镇石缸湾村', '坝坝宴', '36', '6', '0', '0', '36', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], ['四川大区', '五粮春', '五粮春（二代）', '绵阳市润品源商贸有限公司', 'ZD168114', '宇罗粮油副食', 'YX202609201774244', '2026年五粮春宴席（二代）', '家宴', '2026-09-23 12:00:00', '四川省', '绵阳市', '江油市', '武都', '四川省绵阳市江油市武都镇长城路', '104.77747', '31.881277', '画屏园', '大厅', '12', '2', '0', '0', '12', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], ['四川大区', '五粮春', '五粮春（二代）', '自贡五香酒业有限公司', 'ZD729568', '徐健食品经营部', 'YX202609171764473', '2026年五粮春宴席（二代）', '生日宴', '2026-09-23 11:00:00', '四川省', '自贡市', '大安区', '自贡', '四川省自贡市大安区回龙镇红珠村村民委员会', '105.0421', '29.296856', '坝坝宴', '大厅', '40', '8', '6', '0', '54', '0', '0', '0', '0', '0', '8', '6', '0', '0', '0'], ['四川大区', '五粮春', '五粮春（二代）', '四川省欣信智宇商贸有限公司', 'ZD228490', '湘源商贸行', 'YX202609181768854', '2026年五粮春宴席（二代）', '生日宴', '2026-09-23 12:00:00', '四川省', '德阳市', '旌阳区', '旌阳区', '四川省德阳市旌阳区孝感街道东电宾馆(黄河西路)', '104.39347839355469', '31.14703941345215', '柏隆张家院坝', '坝坝', '20', '5', '2', '0', '32', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], ['四川大区', '五粮春', '五粮春（二代）', '四川春享汇供应链管理有限公司', 'ZD1682743714785', '芳惠源食品经营部', 'YX202609181768874', '2026年五粮春宴席（二代）', '生日宴', '2026-09-23 12:00:00', '四川省', '成都市', '成华区', '东和苑', '四川省成都市成华区龙潭街道东和苑(锦绣花城南区店)锦绣花城南区', '104.17187', '30.71063', '东和苑', '大厅', '10', '4', '0', '0', '24', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], ['四川大区', '五粮春', '五粮春（二代）', '成都众诚春香供应链管理有限责任公司', 'ZD1715842729499', '鸿辉商贸', 'YX202609161763050', '2026年五粮春宴席（二代）', '家宴', '2026-09-23 18:00:00', '四川省', '成都市', '新都区', '四川省成都市新都区斑竹园街道安桥村1组88号水云轩生态苑', '四川省成都市新都区斑竹园街道新斑路一段', '104.066376', '30.830765', '水云轩', '水云轩', '18', '3', '0', '0', '18', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], ['四川大区', '五粮春', '五粮春（二代）', '自贡五香酒业有限公司', 'ZD1692762439547', '许平酒坊专卖店', 'YX202609141758569', '2026年五粮春宴席（二代）', '生日宴', '2026-09-23 11:00:00', '四川省', '自贡市', '大安区', '自贡', '四川省自贡市大安区牛佛镇牛佛镇政府', '105.03312', '29.377575', '坝坝宴', '大厅', '40', '5', '0', '0', '30', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], ['四川大区', '五粮春', '五粮春（二代）', '中江腾晖商贸有限公司', 'ZD157952', '通济惠嫒超市', 'YX202609041715064', '2026年五粮春宴席（二代）', '家宴', '2026-09-23 12:00:00', '四川省', '德阳市', '中江县', '中江', '四川省德阳市中江县通济镇245国道', '104.77627', '31.082415', '坝坝宴', '坝坝宴', '18', '5', '0', '0', '30', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], ['四川大区', '五粮春', '五粮春（二代）', '三台玖新品商贸有限公司', 'ZD159912', '鑫泉鑫超市', 'YX202609181768208', '2026年五粮春宴席（二代）', '生日宴', '2026-09-23 00:39:00', '四川省', '绵阳市', '三台县', '金凤凰酒店', '四川省绵阳市三台县北坝镇酪香路66号金凤凰大酒店', '105.08637237548828', '31.095901489257812', '金凤凰酒店', '大厅', '6', '0', '4', '0', '4', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], ['四川大区', '五粮春', '五粮春（二代）', '广元亿祥商贸有限责任公司', 'ZD248046', '长健超市', 'YX202609211776014', '2026年五粮春宴席（二代）', '其他', '2026-09-23 11:00:00', '四川省', '广元市', '旺苍县', '旺苍', '四川省广元市旺苍县东河镇新华街552号米仓山大酒店', '106.28558', '32.22824', '米仓山大酒店', '大厅', '12', '0', '18', '0', '18', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], ['四川大区', '五粮春', '五粮春（二代）', '绵阳聚智商贸有限公司', 'ZD1703476237784', '乐和超市', 'YX202609171765666', '2026年五粮春宴席（二代）', '生日宴', '2026-09-23 12:00:00', '四川省', '绵阳市', '涪城区', '哦', '四川省绵阳市涪城区石塘街道绵阳邦达商贸有限责任公司', '104.73361', '31.447277', '坝坝', '李', '6', '0', '12', '0', '12', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], ['四川大区', '五粮春', '五粮春（二代）', '四川久源道商贸有限公司', 'ZD098499', '九寨沟县酷族超市', 'YX202609211775951', '2026年五粮春宴席（二代）', '甘孜、阿坝、凉山宴席类型(专用)', '2026-09-23 10:00:00', '四川省', '阿坝藏族羌族自治州', '九寨沟县', '九寨沟县城和平一村', '四川省阿坝藏族羌族自治州九寨沟县南坪镇九寨人家老房子客栈', '104.23461', '33.267414', '和平一村', '大厅', '30', '0', '0', '12', '12', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'], ['四川大区', '五粮春', '五粮春（二代）', '绵阳市润品源商贸有限公司', 'ZD181779', '彭氏副食', 'YX202609201774228', '2026年五粮春宴席（二代）', '家宴', '2026-09-23 12:00:00', '四川省', '绵阳市', '江油市', '武都镇', '四川省绵阳市江油市武都镇长城路', '104.77747', '31.881277', '画屏园', '大厅', '12', '0', '3', '0', '3', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0']];

function banquetImportDemoRows() {
  return ROWS.map(function (cells) {
    var row = {};
    HEADERS.forEach(function (header, index) {
      row[header] = cells[index];
    });
    return row;
  });
}

function banquetImportDemoHeader() {
  return HEADERS.map(function (text) {
    return { key: text, text: text };
  });
}

/***/ }),

/***/ 3288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("新宴席管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"sj-icon-add"},on:{"click":_vm.openImport}},[_vm._v("导入")])],1),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.table,"stripe":"","border":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"display_name","label":"名称","min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"link-text",on:{"click":function($event){return _vm.onDownSourceFile(scope.row.id)}}},[_vm._v(_vm._s(scope.row.display_name))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"发起者","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.admin_name)+" ("+_vm._s(scope.row.admin_id)+")\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"上传时间","min-width":"160"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"任务进度","min-width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('sj-progress',{attrs:{"text-inside":true,"stroke-width":18,"status":_vm.taskBatchStatus(scope.row),"percentages":_vm.taskBatchPercentage(scope.row)}}),_vm._v("\n          成功:"+_vm._s(scope.row.success_count)+" 错误:"+_vm._s(scope.row.error_count)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"状态","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.batchStatusLabel(scope.row.status))+"\n          "),(scope.row.status === -2 && scope.row.error_message)?_c('span',[_vm._v(_vm._s(scope.row.error_message))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [([3, -1, -2, -3, -4].includes(scope.row.status) && scope.row.error_count > 0)?_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":function($event){return _vm.onDownErrorFile(scope.row.id)}}},[_vm._v("下载错误行")]):_vm._e()]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":"导入宴席任务","visible":_vm.importVisible,"width":"640px"},on:{"update:visible":function($event){_vm.importVisible=$event},"closed":_vm.resetImport}},[_c('el-form',{attrs:{"label-width":"96px","size":"medium"}},[_c('el-form-item',{attrs:{"label":"客户"}},[_c('remote-select',{key:_vm.customerid || 'customer-empty',staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"输入客户名称/编号","query-request":_vm.getCustomerTable,"find-request":_vm.getCustomerDetail},on:{"change":_vm.onCustomerChange},model:{value:(_vm.customerid),callback:function ($$v) {_vm.customerid=$$v},expression:"customerid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"输入项目名称/编号","disabled":!_vm.customerid,"query-request":_vm.queryProject,"find-request":_vm.getProjectDetail},on:{"change":_vm.onProjectChange},model:{value:(_vm.projectid),callback:function ($$v) {_vm.projectid=$$v},expression:"projectid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"批次"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"detail","value-key":"id","placeholder":"输入批次名称/编号","disabled":!_vm.projectid,"query-request":_vm.queryBatch,"find-request":_vm.getBatchDetail},model:{value:(_vm.batchid),callback:function ($$v) {_vm.batchid=$$v},expression:"batchid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"表格"}},[_c('el-upload',{attrs:{"action":"","auto-upload":false,"limit":1,"accept":".xlsx,.xls,.csv","file-list":_vm.fileList,"on-change":_vm.onFileChange,"on-remove":_vm.onFileRemove}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("选择表格")])],1),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"text"},on:{"click":_vm.downloadDemo}},[_vm._v("下载Demo")])],1)],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.importVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.importing},on:{"click":_vm.submitImport}},[_vm._v("开始导入")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/banquet-task-batch.0a6f1ce0c1572182f7d6.js